/* U.S. States */
import al from '../../../../../assets/state_highways/al.png';
import ak from '../../../../../assets/state_highways/ak.png';
import ar from '../../../../../assets/state_highways/ar.png';
import az from '../../../../../assets/state_highways/az.png';
import ca from '../../../../../assets/state_highways/ca.png';
import co from '../../../../../assets/state_highways/co.png';
import ct from '../../../../../assets/state_highways/ct.png';
import de from '../../../../../assets/state_highways/de.png';
import fl from '../../../../../assets/state_highways/fl.png';
import ga from '../../../../../assets/state_highways/ga.png';
import hi from '../../../../../assets/state_highways/hi.png';
import ia from '../../../../../assets/state_highways/ia.png';
import id from '../../../../../assets/state_highways/id.png';
import il from '../../../../../assets/state_highways/il.png';
import indiana from '../../../../../assets/state_highways/in.png';
import ks from '../../../../../assets/state_highways/ks.png';
import ky from '../../../../../assets/state_highways/ky.png';
import la from '../../../../../assets/state_highways/la.png';
import ma from '../../../../../assets/state_highways/ma.png';
import md from '../../../../../assets/state_highways/md.png';
import me from '../../../../../assets/state_highways/me.png';
import mi from '../../../../../assets/state_highways/mi.png';
import mn from '../../../../../assets/state_highways/mn.png';
import mo from '../../../../../assets/state_highways/mo.png';
import ms from '../../../../../assets/state_highways/ms.png';
import mt from '../../../../../assets/state_highways/mt.png';
import nc from '../../../../../assets/state_highways/nc.png';
import nd from '../../../../../assets/state_highways/nd.png';
import ne from '../../../../../assets/state_highways/ne.png';
import nh from '../../../../../assets/state_highways/nh.png';
import nj from '../../../../../assets/state_highways/nj.png';
import nm from '../../../../../assets/state_highways/nm.png';
import nv from '../../../../../assets/state_highways/nv.png';
import ny from '../../../../../assets/state_highways/ny.png';
import oh from '../../../../../assets/state_highways/oh.png';
import ok from '../../../../../assets/state_highways/ok.png';
import or from '../../../../../assets/state_highways/or.png';
import pa from '../../../../../assets/state_highways/pa.png';
import ri from '../../../../../assets/state_highways/ri.png';
import sc from '../../../../../assets/state_highways/sc.png';
import sd from '../../../../../assets/state_highways/sd.png';
import tn from '../../../../../assets/state_highways/tn.png';
import tn2 from '../../../../../assets/state_highways/tn2.png';
import tx from '../../../../../assets/state_highways/tx.png';
import ut from '../../../../../assets/state_highways/ut.png';
import va from '../../../../../assets/state_highways/va.png';
import vt from '../../../../../assets/state_highways/vt.png';
import wa from '../../../../../assets/state_highways/wa.png';
import wi from '../../../../../assets/state_highways/wi.png';
import wv from '../../../../../assets/state_highways/wv.png';
import wy from '../../../../../assets/state_highways/wy.png';

/* Canada */
import ab from '../../../../../assets/state_highways/ab.png';
import bc from '../../../../../assets/state_highways/bc.png';
import mb from '../../../../../assets/state_highways/mb.png';
import nb from '../../../../../assets/state_highways/nb.png';
import nl from '../../../../../assets/state_highways/nl.png';
import ns from '../../../../../assets/state_highways/ns.png';
import ns2 from '../../../../../assets/state_highways/ns2.png';
import ns3 from '../../../../../assets/state_highways/ns3.png';
import nt from '../../../../../assets/state_highways/nt.png';
import on from '../../../../../assets/state_highways/on.png';
import pe from '../../../../../assets/state_highways/pe.png';
import qc from '../../../../../assets/state_highways/qc.png';
import sk from '../../../../../assets/state_highways/sk.png';
import sk2 from '../../../../../assets/state_highways/sk2.png';
import yk from '../../../../../assets/state_highways/yk.png';
import yk2 from '../../../../../assets/state_highways/yk2.png';
import yk3 from '../../../../../assets/state_highways/yk3.png';
import yk4 from '../../../../../assets/state_highways/yk4.png';

/* show */
import ab_show from '../../../../../assets/state_highways/show/ab.png';
import ak_show from '../../../../../assets/state_highways/show/ak.png';
import az_show from '../../../../../assets/state_highways/show/az.png';
import bc_show from '../../../../../assets/state_highways/show/bc.png';
import ca_show from '../../../../../assets/state_highways/show/ca.png';
import id_show from '../../../../../assets/state_highways/show/id.png';
import il_show from '../../../../../assets/state_highways/show/il.png';
import in_show from '../../../../../assets/state_highways/show/in.png';
import la_show from '../../../../../assets/state_highways/show/la.png';
import mb_show from '../../../../../assets/state_highways/show/mb.png';
import md_show from '../../../../../assets/state_highways/show/md.png';
import mn_show from '../../../../../assets/state_highways/show/mn.png';
import mt_show from '../../../../../assets/state_highways/show/mt.png';
import nb_show from '../../../../../assets/state_highways/show/nb.png';
import nd_show from '../../../../../assets/state_highways/show/nd.png';
import ne_show from '../../../../../assets/state_highways/show/ne.png';
import nt_show from '../../../../../assets/state_highways/show/nt.png';
import nv_show from '../../../../../assets/state_highways/show/nv.png';
import ri_show from '../../../../../assets/state_highways/show/ri.png';
import sc_show from '../../../../../assets/state_highways/show/sc.png';
import tn_show from '../../../../../assets/state_highways/show/tn.png';
import tx_show from '../../../../../assets/state_highways/show/tx.png';
import vt_show from '../../../../../assets/state_highways/show/vt.png';
import wy_show from '../../../../../assets/state_highways/show/wy.png';

export const SHIELD_IMAGES = [
    al, ak, ar, az, ca, co, ct, de, fl, ga, hi, ia, id, il, indiana, ks, ky, la, ma, md, 
    me, mi, mn, mo, ms, mt, nc, nd, ne, nh, nj, nm, nv, ny, oh, ok, or, pa, ri, sc, 
    sd, tn, tn2, tx, ut, va, vt, wa, wi, wv, wy,
    ab, bc, mb, nb, nl, ns, ns2, ns3, nt, on, pe, qc, sk, sk2, yk, yk2, yk3, yk4
];

export const SHIELD_SHOW_IMAGES = [
    ab_show, ak_show, az_show, bc_show, ca_show, id_show, il_show, in_show, la_show, mb_show, 
    md_show, mn_show, mt_show, nb_show, nd_show, ne_show, nt_show, nv_show, ri_show, sc_show, 
    tn_show, tx_show, vt_show, wy_show
]

export const REGION_TO_SHIELD_IMAGES = [
    [3],   // ARIZONA (index 0)
    [2],   // ARKANSAS (index 1)
    [4],   // CALIFORNIA (index 2)
    [5],   // COLORADO (index 3)
    [6],   // CONNECTICUT (index 4)
    [9],   // GEORGIA (index 5)
    [10],  // HAWAII (index 6)
    [13],  // ILLINOIS (index 7)
    [14],  // INDIANA (index 8)
    [17],  // LOUISIANA (index 9)
    [22],  // MINNESOTA (index 10)
    [24],  // MISSISSIPPI (index 11)
    [25],  // MONTANA (index 12)
    [31],  // NEW_MEXICO (index 13)
    [27],  // NORTH_DAKOTA (index 14)
    [35],  // OKLAHOMA (index 15)
    [37],  // PENNSYLVANIA (index 16)
    [41, 42], // TENNESSEE (index 17)
    [45],  // VIRGINIA (index 18)
    [],    // PUERTO_RICO (index 19)
    [7],   // DELAWARE (index 20)
    [49],  // WEST_VIRGINIA (index 21)
    [48],  // WISCONSIN (index 22)
    [50],  // WYOMING (index 23)
    [0],   // ALABAMA (index 24)
    [1],   // ALASKA (index 25)
    [8],   // FLORIDA (index 26)
    [12],  // IDAHO (index 27)
    [15],  // KANSAS (index 28)
    [30],  // NEW_JERSEY (index 29)
    [26],  // NORTH_CAROLINA (index 30)
    [39],  // SOUTH_CAROLINA (index 31)
    [47],  // WASHINGTON (index 32)
    [46],  // VERMONT (index 33)
    [44],  // UTAH (index 34)
    [11],  // IOWA (index 35)
    [16],  // KENTUCKY (index 36)
    [20],  // MAINE (index 37)
    [18],  // MASSACHUSETTS (index 38)
    [21],  // MICHIGAN (index 39)
    [23],  // MISSOURI (index 40)
    [28],  // NEBRASKA (index 41)
    [32],  // NEVADA (index 42)
    [29],  // NEW_HAMPSHIRE (index 43)
    [33],  // NEW_YORK (index 44)
    [34],  // OHIO (index 45)
    [36],  // OREGON (index 46)
    [38],  // RHODE_ISLAND (index 47)
    [40],  // SOUTH_DAKOTA (index 48)
    [43],  // TEXAS (index 49)
    [],    // DISTRICT_OF_COLUMBIA (index 50)
    [19],  // MARYLAND (index 51)
    [],    // MEXICO_STATE_NAMES.SONORA (index 52)
    [],    // MEXICO_STATE_NAMES.BAJA_CALIFORNIA (index 53)
    [],    // MEXICO_STATE_NAMES.CHIHUAHUA (index 54)
    [],    // MEXICO_STATE_NAMES.COAHUILA (index 55)
    [],    // MEXICO_STATE_NAMES.TAMAULIPAS (index 56)
    [],    // MEXICO_STATE_NAMES.NUEVO_LEON (index 57)
    [],    // MEXICO_STATE_NAMES.QUINTANA_ROO (index 58)
    [],    // MEXICO_STATE_NAMES.CAMPECHE (index 59)
    [],    // MEXICO_STATE_NAMES.TABASCO (index 60)
    [],    // MEXICO_STATE_NAMES.CHIAPAS (index 61)
    [],    // MEXICO_STATE_NAMES.COLIMA (index 62)
    [],    // MEXICO_STATE_NAMES.NAYARIT (index 63)
    [],    // MEXICO_STATE_NAMES.BAJA_CALIFORNIA_SUR (index 64)
    [],    // MEXICO_STATE_NAMES.SINALOA (index 65)
    [],    // MEXICO_STATE_NAMES.YUCATAN (index 66)
    [],    // MEXICO_STATE_NAMES.VERACRUZ (index 67)
    [],    // MEXICO_STATE_NAMES.JALISCO (index 68)
    [],    // MEXICO_STATE_NAMES.MICHOACAN (index 69)
    [],    // MEXICO_STATE_NAMES.GUERRERO (index 70)
    [],    // MEXICO_STATE_NAMES.OAXACA (index 71)
    [],    // MEXICO_STATE_NAMES.ESTADO_DE_MEXICO (index 72)
    [],    // MEXICO_STATE_NAMES.PUEBLA (index 73)
    [],    // MEXICO_STATE_NAMES.MORELOS (index 74)
    [],    // MEXICO_STATE_NAMES.QUERETARO (index 75)
    [],    // MEXICO_STATE_NAMES.HIDALGO (index 76)
    [],    // MEXICO_STATE_NAMES.GUANAJUATO (index 77)
    [],    // MEXICO_STATE_NAMES.SAN_LUIS_POTOSI (index 78)
    [],    // MEXICO_STATE_NAMES.ZACATECAS (index 79)
    [],    // MEXICO_STATE_NAMES.AGUASCALIENTES (index 80)
    [],    // MEXICO_STATE_NAMES.DURANGO (index 81)
    [],    // MEXICO_STATE_NAMES.TLAXCALA (index 82)
    [],    // MEXICO_STATE_NAMES.CIUDAD_DE_MEXICO (index 83)
    [56, 57, 58], // CANADA_PROVINCE_NAMES.NOVA_SCOTIA (index 84)
    [61],  // CANADA_PROVINCE_NAMES.QUEBEC (index 85)
    [53],  // CANADA_PROVINCE_NAMES.MANITOBA (index 86)
    [62, 63], // CANADA_PROVINCE_NAMES.SASKATCHEWAN (index 87)
    [51],  // CANADA_PROVINCE_NAMES.ALBERTA (index 88)
    [59],  // CANADA_PROVINCE_NAMES.NORTHWEST_TERRITORIES (index 89)
    [60],  // CANADA_PROVINCE_NAMES.PRINCE_EDWARD_ISLAND (index 90)
    [55],  // CANADA_PROVINCE_NAMES.NEWFOUNDLAND_AND_LABRADOR (index 91)
    [54],  // CANADA_PROVINCE_NAMES.NEW_BRUNSWICK (index 92)
    [64, 65, 66, 67], // CANADA_PROVINCE_NAMES.YUKON (index 93)
    [],    // CANADA_PROVINCE_NAMES.NUNAVUT (index 94)
    [52],  // CANADA_PROVINCE_NAMES.BRITISH_COLUMBIA (index 95)
    [60],  // CANADA_PROVINCE_NAMES.ONTARIO (index 96)
    [],    // TERRITORY_NAMES.AMERICAN_SAMOA (index 97)
    [],    // TERRITORY_NAMES.NORTHERN_MARIANA_ISLANDS (index 98)
    [],    // TERRITORY_NAMES.GUAM (index 99)
    []     // TERRITORY_NAMES.US_VIRGIN_ISLANDS (index 100)
];

export const SHIELD_TO_ANSWER_REGION_INDICES = [
    [24],      // Index 0 (Alabama shield) -> Region 24 (ALABAMA)
    [25],      // Index 1 (Alaska shield) -> Region 25 (ALASKA)
    [1],       // Index 2 (Arkansas shield) -> Region 1 (ARKANSAS)
    [0],       // Index 3 (Arizona shield) -> Region 0 (ARIZONA)
    [2],       // Index 4 (California shield) -> Region 2 (CALIFORNIA)
    [3],       // Index 5 (Colorado shield) -> Region 3 (COLORADO)
    [4],       // Index 6 (Connecticut shield) -> Region 4 (CONNECTICUT)
    [20, 35, 36, 11, 29],      // Index 7 (Delaware shield) -> Region 20 (DELAWARE)
    [26],      // Index 8 (Florida shield) -> Region 26 (FLORIDA)
    [5],       // Index 9 (Georgia shield) -> Region 5 (GEORGIA)
    [6],       // Index 10 (Hawaii shield) -> Region 6 (HAWAII)
    [20, 35, 36, 11, 29],      // Index 11 (Iowa shield) -> Region 35 (IOWA)
    [27],      // Index 12 (Idaho shield) -> Region 27 (IDAHO)
    [7],       // Index 13 (Illinois shield) -> Region 7 (ILLINOIS)
    [8],       // Index 14 (Indiana shield) -> Region 8 (INDIANA)
    [28],      // Index 15 (Kansas shield) -> Region 28 (KANSAS)
    [20, 35, 36, 11, 29],      // Index 16 (Kentucky shield) -> Region 36 (KENTUCKY)
    [9],       // Index 17 (Louisiana shield) -> Region 9 (LOUISIANA)
    [38, 37],      // Index 18 (Massachusetts shield) -> Region 38 (MASSACHUSETTS)
    [51],      // Index 19 (Maryland shield) -> Region 51 (MARYLAND)
    [37, 38],      // Index 20 (Maine shield) -> Region 37 (MAINE)
    [39],      // Index 21 (Michigan shield) -> Region 39 (MICHIGAN)
    [10],      // Index 22 (Minnesota shield) -> Region 10 (MINNESOTA)
    [40],      // Index 23 (Missouri shield) -> Region 40 (MISSOURI)
    [20, 35, 36, 11, 29],      // Index 24 (Mississippi shield) -> Region 11 (MISSISSIPPI)
    [12],      // Index 25 (Montana shield) -> Region 12 (MONTANA)
    [30],      // Index 26 (North Carolina shield) -> Region 30 (NORTH_CAROLINA)
    [14],      // Index 27 (North Dakota shield) -> Region 14 (NORTH_DAKOTA)
    [41],      // Index 28 (Nebraska shield) -> Region 41 (NEBRASKA)
    [43],      // Index 29 (New Hampshire shield) -> Region 43 (NEW_HAMPSHIRE)
    [20, 35, 36, 11, 29],      // Index 30 (New Jersey shield) -> Region 29 (NEW_JERSEY)
    [13],      // Index 31 (New Mexico shield) -> Region 13 (NEW_MEXICO)
    [42],      // Index 32 (Nevada shield) -> Region 42 (NEVADA)
    [44],      // Index 33 (New York shield) -> Region 44 (NEW_YORK)
    [45],      // Index 34 (Ohio shield) -> Region 45 (OHIO)
    [15],      // Index 35 (Oklahoma shield) -> Region 15 (OKLAHOMA)
    [46],      // Index 36 (Oregon shield) -> Region 46 (OREGON)
    [16],      // Index 37 (Pennsylvania shield) -> Region 16 (PENNSYLVANIA)
    [47],      // Index 38 (Rhode Island shield) -> Region 47 (RHODE_ISLAND)
    [31],      // Index 39 (South Carolina shield) -> Region 31 (SOUTH_CAROLINA)
    [48],      // Index 40 (South Dakota shield) -> Region 48 (SOUTH_DAKOTA)
    [17],      // Index 41 (Tennessee shield) -> Region 17 (TENNESSEE)
    [17],      // Index 42 (Tennessee alternate shield) -> Region 17 (TENNESSEE)
    [49],      // Index 43 (Texas shield) -> Region 49 (TEXAS)
    [34],      // Index 44 (Utah shield) -> Region 34 (UTAH)
    [18],      // Index 45 (Virginia shield) -> Region 18 (VIRGINIA)
    [33],      // Index 46 (Vermont shield) -> Region 33 (VERMONT)
    [32],      // Index 47 (Washington shield) -> Region 32 (WASHINGTON)
    [22],      // Index 48 (Wisconsin shield) -> Region 22 (WISCONSIN)
    [21],      // Index 49 (West Virginia shield) -> Region 21 (WEST_VIRGINIA)
    [23],      // Index 50 (Wyoming shield) -> Region 23 (WYOMING)
    [88],      // Index 51 (Alberta shield) -> Region 88 (ALBERTA)
    [95],      // Index 52 (British Columbia shield) -> Region 95 (BRITISH_COLUMBIA)
    [86],      // Index 53 (Manitoba shield) -> Region 86 (MANITOBA)
    [92],      // Index 54 (New Brunswick shield) -> Region 92 (NEW_BRUNSWICK)
    [91],      // Index 55 (Newfoundland and Labrador shield) -> Region 91 (NEWFOUNDLAND_AND_LABRADOR)
    [84],      // Index 56 (Nova Scotia shield) -> Region 84 (NOVA_SCOTIA)
    [84],      // Index 57 (Nova Scotia alternate shield) -> Region 84 (NOVA_SCOTIA)
    [84],      // Index 58 (Nova Scotia alternate shield) -> Region 84 (NOVA_SCOTIA)
    [89],      // Index 59 (Northwest Territories shield) -> Region 89 (NORTHWEST_TERRITORIES)
    [96],      // Index 60 (Ontario shield) -> Region 96 (ONTARIO)
    [85],      // Index 61 (Quebec shield) -> Region 85 (QUEBEC)
    [87],      // Index 62 (Saskatchewan shield) -> Region 87 (SASKATCHEWAN)
    [87],      // Index 63 (Saskatchewan alternate shield) -> Region 87 (SASKATCHEWAN)
    [93],      // Index 64 (Yukon shield) -> Region 93 (YUKON)
    [93],      // Index 65 (Yukon alternate shield) -> Region 93 (YUKON)
    [93],      // Index 66 (Yukon alternate shield) -> Region 93 (YUKON)
    [93]       // Index 67 (Yukon alternate shield) -> Region 93 (YUKON)
];

export const SHIELD_TO_SHOW_INDICES = [
    [],      // Index 0 (Alabama shield) -> No show image
    [1],       // Index 1 (Alaska shield) -> ak_show at index 1
    [],      // Index 2 (Arkansas shield) -> No show image
    [2],       // Index 3 (Arizona shield) -> az_show at index 2
    [4],       // Index 4 (California shield) -> ca_show at index 4
    [],      // Index 5 (Colorado shield) -> No show image
    [],      // Index 6 (Connecticut shield) -> No show image
    [],      // Index 7 (Delaware shield) -> No show image
    [],      // Index 8 (Florida shield) -> No show image
    [],      // Index 9 (Georgia shield) -> No show image
    [],      // Index 10 (Hawaii shield) -> No show image
    [],      // Index 11 (Iowa shield) -> No show image
    [5],       // Index 12 (Idaho shield) -> id_show at index 5
    [6],       // Index 13 (Illinois shield) -> il_show at index 6
    [7],       // Index 14 (Indiana shield) -> in_show at index 7
    [],      // Index 15 (Kansas shield) -> No show image
    [],      // Index 16 (Kentucky shield) -> No show image
    [8],       // Index 17 (Louisiana shield) -> la_show at index 8
    [],      // Index 18 (Massachusetts shield) -> No show image
    [10],      // Index 19 (Maryland shield) -> md_show at index 10
    [],      // Index 20 (Maine shield) -> No show image
    [],      // Index 21 (Michigan shield) -> No show image
    [11],      // Index 22 (Minnesota shield) -> mn_show at index 11
    [],      // Index 23 (Missouri shield) -> No show image
    [],      // Index 24 (Mississippi shield) -> No show image
    [12],      // Index 25 (Montana shield) -> mt_show at index 12
    [],      // Index 26 (North Carolina shield) -> No show image
    [14],      // Index 27 (North Dakota shield) -> nd_show at index 14
    [15],      // Index 28 (Nebraska shield) -> ne_show at index 15
    [],      // Index 29 (New Hampshire shield) -> No show image
    [],      // Index 30 (New Jersey shield) -> No show image
    [],      // Index 31 (New Mexico shield) -> No show image
    [17],      // Index 32 (Nevada shield) -> nv_show at index 17
    [],      // Index 33 (New York shield) -> No show image
    [],      // Index 34 (Ohio shield) -> No show image
    [],      // Index 35 (Oklahoma shield) -> No show image
    [],      // Index 36 (Oregon shield) -> No show image
    [],      // Index 37 (Pennsylvania shield) -> No show image
    [18],      // Index 38 (Rhode Island shield) -> ri_show at index 18
    [19],      // Index 39 (South Carolina shield) -> sc_show at index 19
    [],      // Index 40 (South Dakota shield) -> No show image
    [20],      // Index 41 (Tennessee shield) -> tn_show at index 20
    [20],      // Index 42 (Tennessee alternate shield) -> Same tn_show at index 20
    [21],      // Index 43 (Texas shield) -> tx_show at index 21
    [],      // Index 44 (Utah shield) -> No show image
    [],      // Index 45 (Virginia shield) -> No show image
    [22],      // Index 46 (Vermont shield) -> vt_show at index 22
    [],      // Index 47 (Washington shield) -> No show image
    [],      // Index 48 (Wisconsin shield) -> No show image
    [],      // Index 49 (West Virginia shield) -> No show image
    [23],      // Index 50 (Wyoming shield) -> wy_show at index 23
    [0],       // Index 51 (Alberta shield) -> ab_show at index 0
    [3],       // Index 52 (British Columbia shield) -> bc_show at index 3
    [9],       // Index 53 (Manitoba shield) -> mb_show at index 9
    [13],      // Index 54 (New Brunswick shield) -> nb_show at index 13
    [],      // Index 55 (Newfoundland and Labrador shield) -> No show image
    [],      // Index 56 (Nova Scotia shield) -> No show image
    [],      // Index 57 (Nova Scotia alternate shield) -> No show image
    [],      // Index 58 (Nova Scotia alternate shield) -> No show image
    [16],      // Index 59 (Northwest Territories shield) -> nt_show at index 16
    [],      // Index 60 (Ontario shield) -> No show image
    [],      // Index 61 (Quebec shield) -> No show image
    [],      // Index 62 (Saskatchewan shield) -> No show image
    [],      // Index 63 (Saskatchewan alternate shield) -> No show image
    [],      // Index 64 (Yukon shield) -> No show image
    [],      // Index 65 (Yukon alternate shield) -> No show image
    [],      // Index 66 (Yukon alternate shield) -> No show image
    []       // Index 67 (Yukon alternate shield) -> No show image
];